import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Product } from 'src/app/models/product.model';
import { FavoriteService } from 'src/app/services/favorite.service';
import { I18nService } from 'src/app/services/i18n.service';
import { formatDate } from '../account-sections';

type SavedProduct = Product & { submittedByPseudo?: string; advertiserName?: string };

@Component({
  selector: 'app-saved-deals',
  templateUrl: './saved-deals.component.html',
  styleUrls: ['./saved-deals.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SavedDealsComponent implements OnInit {

  products: SavedProduct[] = [];
  loading = true;
  error = '';

  constructor(
    private favoriteService: FavoriteService,
    private snackBar: MatSnackBar,
    public i18n: I18nService
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.favoriteService.getMyFavoriteProducts().subscribe({
      next: products => {
        this.products = products as SavedProduct[];
        this.loading = false;
      },
      error: err => {
        this.error = err || this.i18n.t('account.loadError');
        this.loading = false;
      }
    });
  }

  isExpired(product: Product): boolean {
    return !!product.expirationDate && new Date(product.expirationDate).getTime() < Date.now();
  }

  date(value: Date | string): string {
    return formatDate(value, this.i18n.current);
  }

  merchant(product: SavedProduct): string {
    return String(product.advertiserName || product.advertiser || '');
  }

  remove(product: Product): void {
    this.favoriteService.toggleFavorite(product._id).subscribe({
      next: () => {
        this.products = this.products.filter(p => p._id !== product._id);
        this.snackBar.open(this.i18n.t('account.saved.removed'), undefined, { duration: 2500 });
      },
      error: err => this.snackBar.open(err || this.i18n.t('common.errorOccurred'), this.i18n.t('common.close'), { duration: 4000 })
    });
  }
}
